export default __webpack_public_path__ + "static/media/pavurya6.04251128.jpg";